import { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


export const MasterContext = createContext();

export const useMasterContext  = () => useContext(MasterContext);

export const MasterContextProvider = ({ children }) => {

    const navigate = useNavigate();

    const [betaStatus, setBetaStatus] = useState(null);
    const [betaRequestTimestamp, setBetaRequestTimestamp] = useState(null);
    const [betaJustApproved, setBetaJustApproved] = useState(false);
  
    const [user, setUser] = useState(() => { // <-- Handles React State update
      try {
        const stored = localStorage.getItem('user');
        if (stored) return JSON.parse(stored);
    
        // Create a new temporary user if none exists
        const newUser = {
          id: 'cj_' + Math.random().toString(36).substring(2, 15), // simple unique per-user Cow Juice id
          createdAt: new Date().toISOString(),
        };
        localStorage.setItem('user', JSON.stringify(newUser));
        return newUser;
      } catch {
        return null;
      }
    });

    const updateUser = (updaterFn) => { // <-- Handles local storage update
      setUser(prev => {
        const updated = updaterFn(prev);
        try {
          localStorage.setItem('user', JSON.stringify(updated));
        } catch (err) {
          console.error('Failed to save user to localStorage:', err);
        }
        return updated;
      });
    };
  
    useEffect(() => {
      const checkBetaStatus = async () => {
        const username = localStorage.getItem('cowjuice_beta_request_username');
        if (!username) return;

        try {
          const res = await fetch(`https://api.gotcowjuice.com:2000/get-beta-testers?username=${username}`, {
            method: 'GET',
            headers: {
              'cow-juice-api-key': process.env.REACT_APP_COWJUICE_API_KEY,
            },
          });
          const data = await res.json();
          if (!Array.isArray(data.requests) || data.requests.length === 0) return;

          const { status, timestamp } = data.requests[0];
          const mappedStatus = status === 'awaiting' ? 'pending' : status;

          const prevStatus = localStorage.getItem('cowjuice_beta_status');
          localStorage.setItem('cowjuice_beta_status', mappedStatus);

          setBetaStatus(mappedStatus);
          setBetaRequestTimestamp(timestamp);

          if (mappedStatus === 'approved' && prevStatus !== 'approved') {
            setBetaJustApproved(true);
          }

        } catch (err) {
          console.error('Failed to fetch beta status:', err);
        }
      };

      checkBetaStatus();
    }, []);


    const value = {
        user,
        setUser,
        updateUser,
        betaStatus,
        betaRequestTimestamp,
        betaJustApproved,
        setBetaJustApproved
    }

    return (
        <MasterContext.Provider value={value}>
            {children}
        </MasterContext.Provider>
    );
};